module.exports = __webpack_public_path__ + "img/168.e27e7951.jpg";